import { LoanCaseDTO } from "@smartx/mikro-vt-client-api"
import { useTranslation } from "react-i18next"
import { IField } from "../../../components/DataList/DataList"
import { DataListComponent } from "../../../Shared"

interface OverViewCardsProps {
  loanCaseData: LoanCaseDTO
}

const OverViewCards: React.FC<OverViewCardsProps> = ({ loanCaseData }) => {
  const { t } = useTranslation()

  const cardData = loanCaseData?.productInstances?.find((el) => !!el)?.cardData

  const fieldArr: Array<IField> = [
    {
      label: t("case.fields.cardData.cardHolder"),
      value: cardData ? cardData.cardHolder : null,
      fieldType: "text",
    },
    {
      label: t("case.fields.cardData.nameOnCard"),
      value: cardData ? cardData.nameOnCard : null,
      fieldType: "text",
    },
    {
      label: t("case.fields.cardData.postingBranchCode"),
      value: cardData ? cardData.postingBranchCode : null,
      fieldType: "text",
    },
    {
      label: t("case.fields.cardData.withdrawalLimit"),
      value: cardData ? cardData.withdrawalLimit : null,
      fieldType: "number",
    },
    {
      label: t("case.fields.cardData.purchaseLimit"),
      value: cardData ? cardData.purchaseLimit : null,
      fieldType: "number",
    },
  ]

  return (
    <DataListComponent
      dataList={fieldArr}
      noResultText={t("case.overview.warnings.noCardData")}
    />
  )
}

export default OverViewCards
